import React from 'react';
import './QuestionBlock.css';
import { formatQuestionStatement } from '../../utils/formatQuestionText';

export const QuestionOption = ({
  index,
  letter,
  text,
  selectable = false,
  selected = false,
  disabled = false,
  status = '',
  onSelect,
  onEliminate,
  tag,
  icon,
}) => {
  const classes = ['question-option-card', status].filter(Boolean).join(' ');
  return (
    <div className={classes}>
      {selectable ? (
        <label className="question-option-label">
          <input
            type="radio"
            className="question-option-input"
            checked={selected}
            disabled={disabled}
            onChange={() => onSelect(index)}
          />
          <span className="question-option-letter">{letter}</span>
          <span className="question-option-text">{text}</span>
        </label>
      ) : (
        <div className="question-option-static">
          <span className="question-option-letter">{letter}</span>
          <span className="question-option-text">{text}</span>
        </div>
      )}
      {tag && <span className="question-option-tag">{tag}</span>}
      {icon}
      {onEliminate && (
        <button
          type="button"
          aria-label="Eliminar alternativa"
          className="option-eliminate-btn no-print"
          onClick={() => onEliminate(index)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="currentColor"><path d="M760-120 480-400l-94 94q8 15 11 32t3 34q0 66-47 113T240-80q-66 0-113-47T80-240q0-66 47-113t113-47q17 0 34 3t32 11l94-94-94-94q-15 8-32 11t-34 3q-66 0-113-47T80-720q0-66 47-113t113-47q66 0 113 47t47 113q0 17-3 34t-11 32l494 494v40H760ZM600-520l-80-80 240-240h120v40L600-520ZM296.5-663.5Q320-687 320-720t-23.5-56.5Q273-800 240-800t-56.5 23.5Q160-753 160-720t23.5 56.5Q207-640 240-640t56.5-23.5ZM494-466q6-6 6-14t-6-14q-6-6-14-6t-14 6q-6 6-6 14t6 14q6 6 14 6t14-6ZM296.5-183.5Q320-207 320-240t-23.5-56.5Q273-320 240-320t-56.5 23.5Q160-273 160-240t23.5 56.5Q207-160 240-160t56.5-23.5Z"/></svg>
        </button>
      )}
    </div>
  );
};

const QuestionBlock = ({
  counterText,
  headerExtra,
  subjectName,
  title,
  imageSrc,
  imageAlt,
  children,
}) => {
  return (
    <>
      {(counterText || headerExtra) && (
        <div className="single-question-header">
          {counterText && <span className="single-question-counter">{counterText}</span>}
          {headerExtra}
        </div>
      )}
      {subjectName && <span className="subject-chip">{subjectName}</span>}
      <h3 className="question-block-title">{formatQuestionStatement(title)}</h3>
      {imageSrc && (
        <div className="question-image">
          <img src={imageSrc} alt={imageAlt} />
        </div>
      )}
      <div className="question-options">
        {children}
      </div>
    </>
  );
};

export default QuestionBlock;
